import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { styled } from "@mui/material/styles";

const menuTextColor = "var(--palette-navigation-text)";
const menuHoverBackgroundColor = "var(--palette-navigation-hoverSurface)";
const tabsShellBorderColor =
  "color-mix(in srgb, var(--palette-navigation-surface) 84%, var(--palette-navigation-text) 16%)";
const inactiveTabBackgroundColor =
  "color-mix(in srgb, var(--palette-navigation-surface) 92%, var(--neutral-white) 8%)";

const TabsShell = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  boxSizing: "border-box",
  margin: "8px 0 16px",
  padding: "4px",
  borderRadius: "var(--radius-container)",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: tabsShellBorderColor,
  backgroundColor: "transparent",
}));

const StyledTabs = styled(Tabs)(() => ({
  width: "100%",
  minHeight: "32px",

  "& .MuiTabs-scroller": {
    display: "flex",
    alignItems: "center",
    overflow: "visible !important",
  },
  "& .MuiTabs-list, & .MuiTabs-flexContainer": {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
    gap: "4px",
    alignItems: "center",
    width: "100%",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  minWidth: 0,
  maxWidth: "none",
  height: "32px",
  minHeight: "32px",
  borderRadius: "var(--radius-control)",
  padding: "0 8px",
  color: menuTextColor,
  backgroundColor: inactiveTabBackgroundColor,
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px",
  textTransform: "none",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",

  "&.Mui-selected": {
    color: theme?.palette?.primary?.contrastText,
    backgroundColor: theme?.palette?.primary?.main,
  },
  "&:not(.Mui-selected):hover": {
    color: theme?.palette?.primary?.main,
    backgroundColor: menuHoverBackgroundColor,
  },
}));

type SocialPostingTabsProps = {
  onSocialPostsClick: () => void;
};

function SocialPostingTabs({ onSocialPostsClick }: SocialPostingTabsProps) {
  return (
    <TabsShell data-testid="social-posting-tabs">
      <StyledTabs aria-label="Advertising surface" value="paid-ads">
        <StyledTab value="paid-ads" label="Paid Ads" disableRipple />
        <StyledTab
          value="social-posts"
          label="Social Posts"
          disableRipple
          onClick={onSocialPostsClick}
        />
      </StyledTabs>
    </TabsShell>
  );
}

export default SocialPostingTabs;
